import React from "react";
import { CgNotes } from "react-icons/cg";
import { RiBarChart2Fill } from "react-icons/ri";
import { Accordion } from "react-bootstrap";
import { PiChatsFill, PiUserCircleFill } from "react-icons/pi";

import {
  emptyString,
  LIST_PAGE_SIZE,
  BOOTSTRAP_SPINNER_SIZE,
  inboxReduxConstants,
  defaultOpenAccordions,
  customerDetailsAccordionsNames,
  PAGINATION_INDEXING,
} from "../../../constants";
import { isSuperOrBrandAdmin } from "../../../../../shared";
import CustomerInfoComponent from "./customerInfoComponent";
import InternalNotesComponent from "./internalNotesComponent";
import CustomerInsightComponent from "./customerInsightComponent";
import PreviousConversationsComponent from "./previousConversationsComponent";
import BootstrapSpinner from "./bootstrapSpinner";
import AccordionSection from "./accordionSection";

const {
  INTERNAL_NOTE,
  CUSTOMER_INFO,
  CUSTOMER_INSIGHT,
  PREVIOUS_CONVERSATIONS,
} = customerDetailsAccordionsNames;

const { FIRST_PAGE_INDEX } = PAGINATION_INDEXING;

const CustomerDetailSidebarComponent = (props) => {
  const {
    user,
    brandId,
    spinner,
    activeKeys,
    setMessage,
    setInputMessage,
    queryParams,
    setActiveKeys,
    selectedGroups,
    selectedStores,
    setShowOffCanvas,
    customerInsights,
    selectedConversation,
    customerPreviewSurvey,
    setSelectedConversation,
    getConversationMessages,
    getCustomerPreviewSurvey,
    getPreviousInternalNotes,
    previousConversationDates,
    getConversationOrderDetails,
    getPreviousConversationDates,
    resetPreviousConversationDates,
  } = props;

  const renderSpinner = () => {
    return (
      <BootstrapSpinner
        size={BOOTSTRAP_SPINNER_SIZE.SM}
        wrapperClassName="d-flex justify-content-center p-2"
      />
    );
  };

  const handleAccordionClick = (key) => {
    setActiveKeys((prevActiveKeys) =>
      prevActiveKeys.includes(key)
        ? prevActiveKeys.filter((k) => k !== key)
        : [...prevActiveKeys, key]
    );
  };

  //Getting previous conversation
  const getPreviousConversations = (
    pageNumber = FIRST_PAGE_INDEX
  ) => {
    getPreviousConversationDates({
      filterQuery: queryParams.filter,
      body: {
        customerId: selectedConversation.customerId,
        brandId: isSuperOrBrandAdmin() ? brandId : user.brandId,
        groupsIds: selectedGroups.map((group) => group.id),
        storesIds: selectedStores.map((store) => store.id),
      },
      length: LIST_PAGE_SIZE,
      pageNumber: pageNumber,
    });
  };

  const getConversationByPreviousDate = (conversation) => {
    const { conversationId, orderId, conversationDate, conversationStatus } =
      conversation;

    getConversationMessages(conversationId, {
      ...selectedConversation,
      id: conversationId,
    });
    getConversationOrderDetails(conversationId);

    setSelectedConversation({
      ...selectedConversation,
      orderId: orderId,
      id: conversationId,
      surveyCompletionDate: conversationDate,
      conversationStatus: conversationStatus,
    });
    setMessage(emptyString);
    setInputMessage(emptyString);
    setActiveKeys(defaultOpenAccordions);
    getCustomerPreviewSurvey(conversationId);
    //Close offcanvas if we click on previous conversation in mobile view
    if (setShowOffCanvas) {
      setShowOffCanvas(false);
    }
  };

  //Get more previous conversation dates
  const getMoreConversationDates = () => {
    const pageNumber = Math.floor(
      previousConversationDates.length / LIST_PAGE_SIZE
    );
    getPreviousConversations(pageNumber);
  };

  return (
    <div
      className="overflow-auto custome-sidebar h-100"
      id="customer-sidebar"
      data-testid="customer-sidebar"
    >
      <Accordion activeKey={activeKeys}>
        <AccordionSection
          eventKey={CUSTOMER_INFO}
          title="Customer Info"
          icon={PiUserCircleFill}
          onHeaderClick={handleAccordionClick}
          headerTestId="customer-info"
          bodyTestId="customer-info-body"
        >
          {spinner(inboxReduxConstants.GET_PREVIEW_CUSTOMER_SURVEY) ? (
            renderSpinner()
          ) : (
            <CustomerInfoComponent
              name={customerPreviewSurvey.name}
              email={customerPreviewSurvey.email}
              phone={customerPreviewSurvey.phone}
            />
          )}
        </AccordionSection>
        <AccordionSection
          eventKey={CUSTOMER_INSIGHT}
          title="Customer Insight"
          icon={RiBarChart2Fill}
          onHeaderClick={handleAccordionClick}
          headerTestId="customer-insight"
          bodyTestId="customer-insight-body"
        >
          {spinner(inboxReduxConstants.GET_CUSTOMER_INSIGHTS) ? (
            renderSpinner()
          ) : (
            <CustomerInsightComponent customerInsights={customerInsights} />
          )}
        </AccordionSection>
        <AccordionSection
          eventKey={PREVIOUS_CONVERSATIONS}
          title="Previous Surveys"
          icon={PiChatsFill}
          onHeaderClick={handleAccordionClick}
          headerTestId="previous-conversations"
          bodyTestId="previous-conversations-body"
          bodyClassName="p-0"
          onEntering={() => {
            resetPreviousConversationDates();
            getPreviousConversations(FIRST_PAGE_INDEX);
          }}
          onExiting={() => resetPreviousConversationDates()}
        >
          <PreviousConversationsComponent
            spinner={spinner}
            selectedConversation={selectedConversation}
            getMoreConversationDates={getMoreConversationDates}
            previousConversationDates={previousConversationDates}
            getConversationByPreviousDate={getConversationByPreviousDate}
          />
        </AccordionSection>
        <AccordionSection
          eventKey={INTERNAL_NOTE}
          title="Internal Notes"
          icon={CgNotes}
          onHeaderClick={handleAccordionClick}
          headerTestId="internal-notes"
          bodyTestId="internal-notes-body"
          bodyClassName="p-0"
          onEntering={() => {
            getPreviousInternalNotes(selectedConversation?.orderId);
          }}
        >
          {spinner(inboxReduxConstants.GET_PREVIOUS_INTERNAL_NOTES) ||
          spinner(inboxReduxConstants.SAVE_INTERNAL_NOTES) ? (
            renderSpinner()
          ) : (
            <InternalNotesComponent
              user={user}
              spinner={spinner}
              selectedConversation={selectedConversation}
              getPreviousInternalNotes={getPreviousInternalNotes}
            />
          )}
        </AccordionSection>
      </Accordion>
    </div>
  );
};

export default React.memo(CustomerDetailSidebarComponent);
